import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import NewsletterComponent from "../../components/newsletter/NewsletterComponent";
import Loading from "../../../components/isLoading";
import { fetchNewsletterData } from "../../../redux//newsletter";
import { Edit, Publish } from "@material-ui/icons";
import { DeleteForever } from "@mui/icons-material";
import DeleteModel from "../DeleteModel";
import { DELETE_NEWSLETTER } from "../../../redux/newsletter/types";
import { toast } from "react-toastify";
import actionCreator from "../../../redux/action/actionCreator";
import ConfirmModel from "../ConfirmModel";

const NewsletterContainer = (props) => {
  const { id } = props;
  const newsletterData = useSelector((state) => state.newsletterGlobalStore);
  const deleteStore = useSelector((store) => store.deleteNewsletterGlobalStore);
  const [state, setState] = useState({
    openDeleteMessage: false,
    openConfirmation: false,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(fetchNewsletterData(id));
    }
  }, []);

  const handleOnEdit = () => navigate("edit");

  const handleOpenCloseConfirmModel = (condition) =>
    setState((prevState) => ({ ...prevState, openConfirmation: condition }));

  const handleOpenCloseDeleteModel = (condition) =>
    setState((prevState) => ({ ...prevState, openDeleteMessage: condition }));

  const isUnpublish = newsletterData.data?.status === "published";

  const crumps = [
    {
      title: "Newsletters",
      path: "/newsletters",
    },
  ];
  const actions = [
    {
      onClick: handleOnEdit,
      text: "Edit Newsletter",
      icon: <Edit fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseConfirmModel(true),
      text: isUnpublish ? "Unpublish Newsletter" : "Publish Newsletter",
      icon: <Publish fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseDeleteModel(true),
      text: "Delete Newsletter",
      icon: <DeleteForever fontSize="small" />,
    },
  ];
  return newsletterData.loading ? (
    <Loading />
  ) : (
    <div>
      <DeleteModel
        isOpen={state.openDeleteMessage}
        isFor="Newsletters"
        handleCloseModel={() => handleOpenCloseDeleteModel(false)}
        itemId={id}
        store={deleteStore}
        action={DELETE_NEWSLETTER}
      />
      <ConfirmModel
        isOpen={state.openConfirmation}
        isFor="Newsletters"
        handleCloseModel={handleOpenCloseConfirmModel}
        itemId={id}
        isUnpublish={isUnpublish}
      />
      <NewsletterComponent
        newsletter={newsletterData.data || {}}
        crumps={crumps}
        actions={actions}
      />
    </div>
  );
};

export default NewsletterContainer;
